<section class="w-full">

    <split-header-section title="Funcionários">
        <p-button label="Cadastrar Funcionário" (click)="cadastrarFuncionario()" severity="primary"></p-button>
    </split-header-section>

    <div [style.padding-right]="'16.002px'" [style.padding-left]="'16.002px'" class="w-full">
        <split-card>
            <div card-header class="grid">
                <div class="col-3">
                    <split-search (valueChange)="filterName($event)"></split-search>
                </div>
                <div class="col-9 flex justify-content-end">
                    <split-group-filter id="filterEmployee" (onFilterEvent)="onFilterChange($event)">
                         <split-filter-option groupId="filterEmployee" field="isActive" [selected]="listActive[0]" label="Ativo" [data]="listActive" key="isActive"></split-filter-option>
                        <split-filter-unit  groupId="filterEmployee" #filter field="units" label="Unidade" key="units"></split-filter-unit>
                    </split-group-filter>
                </div>
            </div>

            <split-table #idTable card-body [filters]="filters" [paginator]="true" [loading]="isLoading" [checklist]="false"
                         [totalRecords]="totalItems" (pageChange)="onPageChange($event)"
                         [widthColumns]="[5, 25, 20, 15, 20, 15]"
                         [dados]="(employeeList$ | async)!" theme="primary">

                <ng-template #header> </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div [ngClass]="!item?.isActive? 'inativo': ''">
                        <img class="profile border-circle" src="assets/avatar/Avatar.png" alt="foto do funcionario">
                    </div>
                </ng-template>

                <ng-template #header>
                    <div class="text-left"[style.padding-left]="'10px'"> Nome </div>
                </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div [ngClass]="!item?.isActive? 'inativo': ''">
                        <split-text class="text-left" [title]="item?.name" [subtitle]="item.email"></split-text>
                    </div>
                </ng-template>

                <ng-template #header>Telefone</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div [ngClass]="!item?.isActive? 'inativo': ''">
                        {{item.contactNumber | formatPhoneNumber}}
                    </div>
                </ng-template>

                <ng-template #header>Profissão</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div [ngClass]="!item?.isActive? 'inativo': ''">
                         {{ this.setProfessionName( item.profession) }}
                    </div>
                </ng-template>


                <ng-template #header>Unidades</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <!-- {{setUnitList(item.units)}} -->
                    <div [ngClass]="!item?.isActive? 'inativo': ''">
                        <!-- {{item.units[0]?.unitName}} -->
                        {{setUnitList(item.units)[0]}}
                        <p-badge *ngIf="item.units.length > 1" class="pl-1" [pTooltip]="tooltipContent"
                            tooltipPosition="bottom" value="+{{item.units.length - 1}}"></p-badge>
                        <ng-template #tooltipContent>
                            <div class="flex flex-column justify-content-start align-items-start">
                                <span class="p-0 text- py-1" *ngFor="let unidade of setUnitList(item.units).slice(1)">
                                    {{unidade}}
                                </span>
                            </div>
                        </ng-template>
                    </div>

                </ng-template>

                <ng-template #header></ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div class="w-auto flex justify-content-end">
                        <div [ngClass]="!item?.isActive? 'inativo': ''">
                            <button class="action border-circle bg-white w-2rem h-2rem mr-4"
                                (click)="editarFuncionario(item)" pTooltip="Editar Funcionário">
                                <img src="assets/lista-unidade/editar.svg" alt="Editar Funcionário" />
                            </button>
                        </div>


                        <ng-template [ngIf]="item?.isActive">
                            <button class="action border-circle bg-white w-2rem h-2rem mr-4"
                                (click)="inativarFuncionario(item)" pTooltip="Inativar Funcionário">
                                <img src="assets/lista-unidade/inativar.svg" alt="Inativar Funcionário" />
                            </button>
                        </ng-template>

                        <ng-template [ngIf]="!item?.isActive">
                            <button class="action border-circle bg-white w-2rem h-2rem mr-4"
                                (click)="ativarFuncionario(item)" pTooltip="Ativar Funcionário">
                                <img src="assets/cadastro/active.svg" alt="ativar Funcionário" />
                            </button>
                        </ng-template>

                        <button class="action border-circle bg-white w-2rem h-2rem mr-4"
                            (click)="deletarFuncionario(item.id)" pTooltip="Deletar Funcionário">
                            <img src="assets/lista-unidade/excluir.svg" alt="Excluir Funcionário" />
                        </button>
                    </div>
                </ng-template>

            </split-table>


        </split-card>
    </div>


</section>



<!-- ---------------------------------------------- -->

<!-- dialog confirmação deletar / inativar -->

<!-- ---------------------------------------------- -->

<p-dialog [(visible)]="mostrarModalDeletar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/lista-unidade/modal-deletar/deletar-unidade.svg" alt="imagem deletar funcionario">
        <span class="title">
            <p>Tem certeza que deseja deletar</p>
            <p>esse funcionário?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você excluirá permanentemente</p>
            <p>o funcionário selecionado</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="deletar" (click)="onDelete()">Deletar</button>
    </ng-template>

</p-dialog>

<p-dialog [(visible)]="mostrarModalInativar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="imagem inativar funcionario">
        <span class="title">
            <p>Tem certeza que deseja inativar</p>
            <p>esse funcionário?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você inativará esse funcionário da sua listagem</p>
            <p>padrão.</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="inativar" (click)="inativarFuncionarioPatch()">Inativar</button>
    </ng-template>

</p-dialog>

<p-dialog [(visible)]="mostrarModalAtivar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/cadastro/active_modal.svg" alt="imagem deletar funcionario">
        <span class="title">
            <p>Tem certeza que deseja ativar</p>
            <p>esse funcionário?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você irá ativar esse funcionário na sua listagem</p>
            <p> padrão</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="ativar" (click)="ativarFuncionarioPatch()">Ativar</button>
    </ng-template>

</p-dialog>
